import { Dispatch, SetStateAction } from "react";
import { styled } from "styled-components";

export default function Hexagon({
  color,
  showBorder,
  setColor,
}: {
  color: string;
  showBorder: boolean;
  setColor: Dispatch<SetStateAction<string>>;
}) {
  return (
    <HexagonContainer
      width="14px"
      height="16.17px"
      color={showBorder ? "white" : color}
      onClick={() => setColor(color)}
    >
      {showBorder && (
        <HexagonContainer width="10px" height="12.17px" color={color} />
      )}
    </HexagonContainer>
  );
}

 const HexagonContainer = styled.div<{
  width: string;
  height: string;
  color: string;
}>`
  background: ${({ color }) => color};
  width: ${({ width }) => width};
  height: ${({ height }) => height};
  display: flex;
  justify-content: center;
  align-items: center;
  clip-path: polygon(0% 25%, 50% 0%, 100% 25%, 100% 75%, 50% 100%, 0% 75%);
  cursor: pointer;
`;
